<div class="mb-3">
  <div>

    <h1 class="pb-2 border-bottom fw-light" i18n>Rechnungen</h1>

    <div class="mt-3">
      <app-invoice-search (searchCriteria)="search($event)"></app-invoice-search>
    </div>

    <kendo-grid
      [data]="list.gridData"
      [pageable]="true"
      [skip]="list.state.skip"
      [pageSize]="list.state.pageSize"
      [sortable]="true"
      [sort]="list.state.sort"
      (pageChange)="list.onPageChange($event)"
      (sortChange)="list.onSortChange($event)"
      [reorderable]="true"
      [resizable]="true">
      <ng-template kendoGridNoRecordsTemplate>
        <app-grid-no-records [loading]="list.loading" loadingText="Rechnungen werden geladen…" i18n-loadingText></app-grid-no-records>
      </ng-template>
      <ng-template kendoGridToolbarTemplate>
        <button kendoGridPDFCommand icon="file-pdf" i18n>PDF-Export</button>
        @if (profile?.customer.isRetailer && profile?.isActive) {
          <button class="btn btn-primary ms-auto" [routerLink]="['/shop-invoice-orders']" i18n>
            Rechnungen erstellen
          </button>
        }
      </ng-template>
      @if (profile?.customer.isRetailer) {
        <kendo-grid-column field="recipientCustomerFullName" [sortable]="false" i18n-title
        title="Kunde"></kendo-grid-column>
      }
      <kendo-grid-column field="invoiceNumber" i18n-title title="Rechnungsnummer">
      </kendo-grid-column>
      <kendo-grid-column field="invoiceView.cancelledInvoiceNumber" [sortable]="false" i18n-title title="Ursprungs-Re.-Nr.">
      </kendo-grid-column>
      <kendo-grid-column i18n-title title="Kategorie" [width]="130">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ getInvoiceCategoryDescription(dataItem) }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="invoiceDateTime" title="Rechnungsdatum" i18n-title format="{0:g}"></kendo-grid-column>
      <kendo-grid-column field="grossPrice" [sortable]="false" i18n-title title="VK">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.grossPrice | currency: dataItem.currency }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="discountedGrossPrice" [sortable]="false" i18n-title title="EK">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.discountedGrossPrice | currency: dataItem.currency }}
        </ng-template>
      </kendo-grid-column>

      <!-- 130px: zwei Kendo-Command-Buttons (je 46px) + gap-2 (8px) + Zellen-Padding (2x8px)
           brauchen 116px; bei 100px liefen die Icons links aus der Zelle heraus (#100). -->
      <kendo-grid-command-column i18n-title title="" [width]="130">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-end gap-2">
            @if (dataItem.invoiceCategory == InvoiceCategoryConstants.invoice && !dataItem.cancellationInvoiceId) {
              <button type="button" class="btn btn-sm btn-outline-danger" title="Rechnung stornieren" aria-label="Rechnung stornieren" i18n-title i18n-aria-label [asyncClick]="onCancel(dataItem.id)" [disabled]="cancelBtn.disabled" #cancelBtn="asyncClick">
                <i>
                  @if (cancelBtn.busy) { <span class="spinner-border spinner-border-sm"></span> } @else {
                  <fa-icon [icon]="faTimes"></fa-icon>
                  }
                </i>
              </button>
            }
            <button type="button" class="btn btn-sm btn-outline-secondary" title="PDF herunterladen" aria-label="PDF herunterladen" i18n-title i18n-aria-label (click)="downloadInvoiceDocument(dataItem.id)">
              <i><fa-icon [icon]="faFilePdf"></fa-icon></i>
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>

      <kendo-grid-pdf appGridPdf fileName="Rechnungen.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [scale]="0.75">
        <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
        <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
          <app-pdf-page title="Rechnungen" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
        </ng-template>
      </kendo-grid-pdf>
    </kendo-grid>
  </div>
</div>
